var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnbnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 450,
    fill: "#BCB2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.693 242.866L448.206 150.597L606.72 242.866L548.443 276.952L448.206 218.77L347.97 276.952L289.693 242.866ZM648.097 567.863L547.861 626.045V694.218L706.374 601.949V417.412L648.097 451.499V567.863ZM589.82 301.048L648.097 335.135V403.308L706.374 369.221V301.048L648.097 266.962L589.82 301.048ZM389.929 650.728V718.901L448.206 752.988L506.483 718.901V650.728L448.206 684.815L389.929 650.728ZM248.316 335.135L306.593 301.048L248.316 266.962L190.039 301.048V369.221L248.316 403.308V335.135ZM248.316 451.499L190.039 417.412V601.949L348.552 694.218V626.045L248.316 567.863V451.499Z",
    fill: "#231F2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.206 266.962L289.693 359.23V543.767L448.206 636.036L606.72 543.767V359.23L448.206 266.962Z",
    fill: "#231F2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.804 399.551C400.804 427.762 421.587 449.371 449.5 449.997L449.5 404.904C504.532 405.515 546 446.46 546 500.449C546 554.845 503.904 596 448.251 596C399.734 596 361.919 564.865 353 521.563H402.231C410.08 539.099 427.203 550.908 448.251 550.908C476.791 550.908 498.196 529.078 498.196 500.449C498.196 472.238 477.413 450.629 449.5 450.003L449.5 495.096C394.468 494.485 353 453.54 353 399.551C353 345.155 395.096 304 450.749 304C499.266 304 537.081 335.135 546 378.437H496.769C488.92 360.901 471.797 349.092 450.749 349.092C422.209 349.092 400.804 370.922 400.804 399.551Z",
    fill: "#BCB2FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnbnb);
export default __webpack_public_path__ + "static/media/snbnb.aadb85b346ac4d61bc4e071caf5a8e9e.svg";
export { ForwardRef as ReactComponent };